export default {
  name: 'VerticalLineComponent',
  props: ['complete'],
  data() {
    return {
    };
  },
  methods: {
  },
};
